module.exports = __webpack_public_path__ + "img/1006.3d92944f.png";